import React, { Component } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import { hostname } from '../host';
import { getAccessToken } from '../auth/AuthService';
import '../theme/misanthropy.css';

import { AddIcon, DeleteIcon, PeopleIcon, PersonIcon } from './MisIcons';

class MisLobby extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessions: [],
      loading: true,
      createOpen: false,
      newTitle: '',
      newCampaignNotes: ''
    };
    this.onKey = this.onKey.bind(this);
  }

  componentDidMount() {
    this.load();
    document.addEventListener('keydown', this.onKey);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKey);
  }

  onKey(e) {
    if (e.key === 'Escape' && this.state.createOpen) {
      this.setState({ createOpen: false });
    }
  }

  get headers() {
    return { Authorization: 'Bearer ' + getAccessToken() };
  }

  load() {
    axios.get(hostname() + 'rest/misanthropy/sessions', { headers: this.headers })
      .then(res => this.setState({ sessions: res.data, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  delete(id) {
    if (!window.confirm('Delete this session and all its messages?')) return;
    axios.delete(hostname() + 'rest/misanthropy/sessions/' + id, { headers: this.headers })
      .then(() => this.setState(prev => ({ sessions: prev.sessions.filter(s => s.id !== id) })))
      .catch(err => console.error(err));
  }

  create() {
    const { newTitle, newCampaignNotes } = this.state;
    if (!newTitle.trim()) return;
    axios.post(hostname() + 'rest/misanthropy/sessions',
      { title: newTitle.trim(), campaignNotes: newCampaignNotes },
      { headers: this.headers }
    ).then(res => {
      this.setState({ createOpen: false, newTitle: '', newCampaignNotes: '' });
      this.props.history.push('/misanthropy/sessions/' + res.data.id);
    }).catch(err => console.error(err));
  }

  render() {
    const { sessions, loading, createOpen, newTitle, newCampaignNotes } = this.state;

    return (
      <div className="mis-page">
        <div className="mis-inner">
          <p className="mis-kicker">Newfangle Press</p>
          <h1 className="mis-h1">Misanthropy</h1>
          <p className="mis-lede">
            AI players around your table. Roll a party, seat them, and run the scene.
          </p>

          <h2 className="mis-section-h">
            Sessions
            <span className="mis-section-actions">
              <NavLink className="mis-btn mis-btn-ghost mis-btn-sm" to="/misanthropy/personas">
                <PeopleIcon /> Personas
              </NavLink>
              <NavLink className="mis-btn mis-btn-ghost mis-btn-sm" to="/misanthropy/pcs">
                <PersonIcon /> Characters
              </NavLink>
            </span>
          </h2>

          {loading &&
            <div className="mis-loading"><div className="mis-spinner" /></div>}

          {!loading &&
            <div className="mis-grid">
              {sessions.map(session => (
                <div className="mis-card" key={session.id}>
                  <div className="mis-card-body">
                    {session.status &&
                      <span className="mis-chip">{session.status}</span>}
                    <h3 className="mis-card-title" title={session.title}>{session.title}</h3>
                    {session.campaignNotes &&
                      <p className="mis-card-desc">{session.campaignNotes}</p>}
                  </div>
                  <div className="mis-card-foot">
                    <NavLink className="mis-btn mis-btn-primary mis-btn-sm"
                      to={'/misanthropy/sessions/' + session.id}>
                      Open
                    </NavLink>
                    <span className="mis-foot-right">
                      <button className="mis-icon-btn mis-icon-btn-sm mis-danger"
                        title="Delete session" onClick={() => this.delete(session.id)}>
                        <DeleteIcon />
                      </button>
                    </span>
                  </div>
                </div>
              ))}

              {sessions.length === 0 &&
                <p className="mis-empty">No sessions yet. Press + to create one.</p>}
            </div>}
        </div>

        <button className="mis-fab" title="New session"
          onClick={() => this.setState({ createOpen: true })}>
          <AddIcon />
        </button>

        {createOpen &&
          <div className="mis-backdrop" role="dialog" aria-modal="true"
            onClick={e => { if (e.currentTarget === e.target) this.setState({ createOpen: false }); }}>
            <div className="mis-modal">
              <div className="mis-modal-head">
                <h2 className="mis-modal-title">New Session</h2>
              </div>
              <div className="mis-modal-body">
                <div className="mis-field">
                  <label className="mis-field-label">Title</label>
                  <input className="mis-input" autoFocus value={newTitle}
                    onChange={e => this.setState({ newTitle: e.target.value })}
                    onKeyDown={e => { if (e.key === 'Enter') this.create(); }} />
                </div>
                <div className="mis-field">
                  <label className="mis-field-label">Campaign Notes</label>
                  <textarea className="mis-textarea" rows={5} value={newCampaignNotes}
                    onChange={e => this.setState({ newCampaignNotes: e.target.value })} />
                  <p className="mis-help">World context, tone, and setting — injected into every LLM prompt.</p>
                </div>
              </div>
              <div className="mis-modal-foot">
                <button className="mis-btn mis-btn-quiet"
                  onClick={() => this.setState({ createOpen: false })}>Cancel</button>
                <button className="mis-btn mis-btn-primary" disabled={!newTitle.trim()}
                  onClick={() => this.create()}>Create</button>
              </div>
            </div>
          </div>}
      </div>
    );
  }
}

export default MisLobby;
